import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./Component/Dashboard/Dashboard";
import Login from "./Component/Login/Login";
import Error from "./Component/Login/Error";
import Overview from "./Component/Login/Overview";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Error />}></Route>
        <Route path="/dashboard" element={<Dashboard />}></Route>
        <Route path="/:link_ref_address" element={<Login />}></Route>
        <Route path="/definaddress" element={<Overview />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;